import NcInputNumber from "components/NcInputNumber/NcInputNumber";
import React, { useEffect, useState } from "react";
import { FC } from "react";
import { useClient } from "ClientContext";
import { useTranslation } from "react-i18next";

export interface GuestsInputProps {
  defaultValue?: any;
  onChange?: (data: any) => void;
  className?: string;
}

const GuestsInput: FC<GuestsInputProps> = ({
  defaultValue,
  onChange,
  className = "",
}) => {
  const {t} = useTranslation()
  const { global_searh,setGlobal_search,global_max_guests } = useClient(); 
  const initialGuestCount = defaultValue?.guestAdults || global_searh?.params?.guestsCount || 0;
  const [guestInputValue, setGuestInputValue] = useState(initialGuestCount);

  const max_guests = global_max_guests > 1 ? global_max_guests : 25;
  useEffect(() => {
    setGuestInputValue(initialGuestCount);
  }, [initialGuestCount]);

  const handleChangeData = (value: number) => {
    setGuestInputValue(value);
    onChange?.({ guestAdults: value });

    // Update booking data when guests change
    setGlobal_search((prevData) => ({
      ...prevData,
      params: {
        ...prevData.params,
        guestsCount: value,
      },
    }));
  };

  if (!max_guests) {
    return null; 
  }

  return (
    <div className={`flex flex-col relative p-5 ${className}`}>
      <span className="mb-5 block font-semibold text-xl sm:text-2xl">
      {t('How many people?')}
      </span>
      <NcInputNumber
        className="w-full"
        defaultValue={guestInputValue} 
        onChange={handleChangeData}
        max={max_guests}
        min={1}
        label={t("Guests")}
        desc={t("How many people?")}
      />
    </div>
  );
};

export default GuestsInput;